import { NavigateFunction } from 'react-router-dom';

let nav: NavigateFunction | undefined;
export const setNavigate = (n: NavigateFunction) => { nav = n; };
export const navigate = (path: string) => {
  if (nav) nav(path);
};
